import React from 'react';
import COButton from 'shared/components/COButton';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import { ReactComponent as Edit } from 'assets/icons/draft.svg';
import { ReactComponent as VerifiedIcon } from 'assets/icons/verified.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { ReactComponent as ApprovalReportIcon } from 'assets/icons/app-report.svg';
import { ReactComponent as Declined } from 'assets/icons/declined.svg';
import { AllProductListTableFields } from 'enums/AllProductListEnums';
import { ProductOverviewEnums } from 'enums/ProductOverviewEnums';
import { CommodityOverview } from 'models/Farmbox/overview.model';
import styles from './overviewHeader.module.scss';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
interface FarmHeaderProps {
  loading: boolean;
  farmboxOverview: CommodityOverview | undefined;
  harvestYearSpan: string;
  navigateBack: () => void;
  cancelCallback: () => void;
  editNavigateHandler: () => void;
  approvalHandler: () => void;
  handleReport: () => void;
  isViewerRole?: boolean;
}

const FarmHeader: React.FC<FarmHeaderProps> = ({
  loading,
  farmboxOverview,
  harvestYearSpan,
  navigateBack,
  cancelCallback,
  editNavigateHandler,
  approvalHandler,
  handleReport,
  isViewerRole = false,
}) => {
  const handleViewMore = () => {
    editNavigateHandler();
  };

  const handleEditClick = () => {
    if (isViewerRole) {
      Notification({
        message: "You don't have admin access to add location and year",
        description: '',
        type: NotificationTypes.WARNING,
      });
      return;
    }
    editNavigateHandler();
  };
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.headerContainer}>
        <div className={styles.headerDetailsContainer}>
          {!loading && (
            <div className={styles.backIconContainer}>
              <BackIcon onClick={navigateBack} className={styles.backIcon} />
            </div>
          )}
          <div>
            <span className={styles.commodityName}>
              {farmboxOverview?.name}
            </span>
          </div>
          {farmboxOverview?.status === AllProductListTableFields.DRAFT ? (
            <div className={styles.draftStatus}>
              <Edit className={styles.editIcon} />
              <span className={styles.status}>{farmboxOverview?.status}</span>
            </div>
          ) : farmboxOverview?.status === AllProductListTableFields.APPROVED ? (
            <div className={styles.approvedStatus}>
              <VerifiedIcon className={styles.verifiedIconGreen} />
              <span className={styles.status}>{farmboxOverview?.status}</span>
            </div>
          ) : farmboxOverview?.status === AllProductListTableFields.DECLINED ? (
            <div className={styles.declinedStatus}>
              <Declined className={styles.declinedIcon} />
              <span className={styles.status}>{farmboxOverview?.status}</span>
            </div>
          ) : (
            !loading && (
              <div className={styles.inReviewStatus}>
                <SearchIcon className={styles.inReviewIconYellow} />
                <span className={styles.status}>{farmboxOverview?.status}</span>
              </div>
            )
          )}
        </div>
        {farmboxOverview?.status === AllProductListTableFields.DRAFT ? (
          <div className={styles.headerActionsContainer}>
            <COButton onClick={cancelCallback} text>
              Cancel
            </COButton>
            <COButton onClick={handleEditClick} secondary disabled={isViewerRole}>
              Edit
            </COButton>
            <COButton onClick={approvalHandler} primary>
              Submit for approval
            </COButton>
          </div>
        ) : farmboxOverview?.status === AllProductListTableFields.APPROVED ? (
          <div className={styles.headerActionsContainer}>
            <COButton onClick={cancelCallback} text>
              Close
            </COButton>
            <COButton text onClick={handleReport}>
              <div className={styles.downloadBtn}>
                <div className={styles.downloadIconContainer}>
                  <ApprovalReportIcon
                    className={styles.productIcon}
                    onClick={handleReport}
                  />
                </div>
                {ProductOverviewEnums.APPROVAL_REPORT}
              </div>
            </COButton>
            <COButton onClick={handleViewMore} secondary>
              View More
            </COButton>
          </div>
        ) : (
          !loading && (
            <div className={styles.headerActionsContainer}>
              <COButton onClick={cancelCallback} text>
                Close
              </COButton>
              <COButton onClick={handleViewMore} secondary>
                View More
              </COButton>
            </div>
          )
        )}
      </div>
      {!loading && (
        <div className={styles.reportingYear}>{harvestYearSpan}</div>
      )}
    </div>
  );
};

export default FarmHeader;
